import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import "../Add-Publisher/addPublisher.css";

const EditPublisher = () => {
    const { pubid } = useParams();
    const navigate = useNavigate();
    const [errors, setErrors] = useState({});
    const [message, setMessage] = useState("");
    const [passwordChanged, setPasswordChanged] = useState(false);
    const [publisherData, setPublisherData] = useState({
      account_name: "",
      username: "",
      contact_person:"",
      password: "",
      email: "",
      phone: "",
      company_name: "",
      brand_name: "",
      address: "",
      country: "",
      pricing_model: "",
      fixed_fee: "",
      revenue_sharing: "",
      website_url: "",
      status: "",
      show_request:"", 
      show_impression:"", 
      show_ctr:"", 
      show_pubRev:"", 
      show_pub_eCPM:"", 

    //   pubId:"",
    //   acc_user_id:""
    });

    const fetchPublisher = async () => {
        try {
          const token = localStorage.getItem("token");
          const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/admin/getPublisher/${pubid}`, {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
              Accept: "application/json",
            },
          });
          const publisherInfo = response.data.data[0];          
          // setPublisherData({...fetchedData, password: ""});
          // delete publisherInfo.password; // Remove encrypted password
          setPublisherData(publisherInfo);
        } catch (error) {
          if (error.response?.status === 401) {
            console.error("Unauthorized! Token might be expired.");
            localStorage.removeItem("token");
            navigate("/");
          } else {
            console.error("Error fetching data:", error);
          }
          console.error("Error fetching publisher:", error);
        }
      };

    useEffect(() => {
     fetchPublisher();
    }, [pubid]);

    // Handle input changes
     const handleChange = (e) => {
      const { name, value } = e.target;
      if (name === "password") {
          setPasswordChanged(true); // Mark password as changed
      }
      setPublisherData({ ...publisherData, [name]: value });
  };

    // Handle form submission
    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
        const token = localStorage.getItem("token");
        const requestData = {
            ...publisherData,
            pubId: publisherData.account_id,
            acc_user_id: publisherData.acc_user_id,
          };
          if (!passwordChanged) {
            delete requestData.password; // Remove password if not changed
        }
        const payloadRes = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/admin/updatePublisher`, requestData, {
            headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
            Accept: "application/json",
            },
        });
        if(payloadRes.status === 200){
            alert("Publisher updated successfully!");
            navigate("/publisher-list"); // Redirect to list page
        }
        } catch (error) {
        console.error("Error updating publisher:", error);
        }
    };

    return (
    <section className="createPub mainContainer">
    <div className="publisher-form-card">
      <div className="publisher-form-header">
      <h3>Update Publisher</h3>
      <p>
        Update a publisher account and configure reporting preferences.
      </p>
    </div>
     {/* Form Body */}
     <div className="publisher-form-body">
      {message && <p className="alert alert-info">{message}</p>}
        <form onSubmit={handleSubmit}>
          {/* ACCOUNT  INFORMATION */}
          <div className="form-section">
            <h4 className="form-section-title">
              Account Information
            </h4>
            <div className="row">
              <div className="col-md-4">
                <div className="publisher-field">
                <label>Account Name:</label>
                <input
                  type="text"
                  name="account_name"
                  className="form-control"
                  value={publisherData?.account_name}
                  onChange={handleChange}
                />
                {errors?.account_name && <p className="text-danger">{errors?.account_name[0]}</p>}
                </div>
              </div>

              <div className="col-md-4">
                <div className="publisher-field">
                <label>Username:</label>
                <input
                  type="text"
                  name="username"
                  className="form-control"
                  value={publisherData?.username}
                  onChange={handleChange}
                />
                {errors?.username && <p className="text-danger">{errors?.username[0]}</p>}
                </div>
              </div>
              <div className="col-md-4">
                <div className="publisher-field">
                <label>Contact Person:</label>
                <input
                  type="text"
                  name="contact_person"
                  className="form-control"
                  value={publisherData?.contact_person}
                  onChange={handleChange}
                />
                {errors?.username && <p className="text-danger">{errors?.username[0]}</p>}
                </div>
              </div>
            </div>
          
          <div className="row">
            <div className="col-md-6">
              <div className="publisher-field">
              <label>Password:</label>
              <input
                type="password"
                name="password"
                className="form-control"
                value={publisherData?.password || ""}
                onChange={handleChange}
              />
              </div>
            </div>

            <div className="col-md-6">
               <div className="publisher-field">
              <label>Email:</label>
              <input
                type="email"
                name="email"
                className="form-control"
                value={publisherData?.email}
                onChange={handleChange}
              />
              {errors.email && <p className="text-danger">{errors.email[0]}</p>}
              </div>
            </div>
          </div>
        </div>

        {/* COMPANY INFORMATION */}
        <div className="form-section">
          <h4 className="form-section-title">
            Company Information
          </h4>
          <div className="row">
            <div className="col-md-6">
              <div className="publisher-field">
              <label>Phone:</label>
              <input
                type="text"
                name="phone"
                className="form-control"
                value={publisherData?.phone}
                onChange={handleChange}
              />
              </div>
            </div>

            <div className="col-md-6">
              <div className="publisher-field">
              <label>Company Name:</label>
              <input
                type="text"
                name="company_name"
                className="form-control"
                value={publisherData?.company_name}
                onChange={handleChange}
              />
              </div>
            </div>
          </div>
        
          <div className="row">
            <div className="col-md-6">
              <div className="publisher-field">
              <label>Brand Name:</label>
              <input
                type="text"
                name="brand_name"
                className="form-control"
                value={publisherData?.brand_name}
                onChange={handleChange}
              />
              </div>
            </div>

            <div className="col-md-6">
              <div className="publisher-field">
              <label>Address:</label>
              <input
                type="text"
                name="address"
                className="form-control"
                value={publisherData?.address}
                onChange={handleChange}
              />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-6">
              <div className="publisher-field">
              <label>Country:</label>
              <input
                type="text"
                name="country"
                className="form-control"
                value={publisherData?.country}
                onChange={handleChange}
              />
              </div>
            </div>
            <div className="col-md-6">
              <div className="publisher-field">
              <label>Website URL:</label>
              <input
                type="text"
                name="website_url"
                className="form-control"
                value={publisherData?.website_url}
                onChange={handleChange}
              />
              {errors.website_url && <p className="text-danger">{errors.website_url[0]}</p>}
              </div>
            </div>
          </div>
        </div>
        {/* PRICING & ACCOUNT */}
        <div className="form-section">
            <h4 className="form-section-title">
              Pricing & Account Settings
            </h4>
            <div className="row">
              <div className="col-md-6">
                <div className="publisher-field">
                <label>Pricing Model:</label>
                <select
                  name="pricing_model"
                  className="form-control"
                  value={publisherData?.pricing_model}
                  onChange={handleChange}
                >
                  <option value="1">Revenue Sharing</option>
                  <option value="0">Fixed Price</option>
                  <option value="2">Both</option>
                </select>
                </div>
              </div>
              <div className="col-md-6">
                <div className="publisher-field">
                <label>Status:</label>
                <select
                  name="status"
                  className="form-control"
                  value={publisherData?.status}
                  onChange={handleChange}
                >
                  <option value="1">Inactive</option>
                  <option value="0">Active</option>
                </select>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6">
                <div className="publisher-field">
                <label>Fixed Fee:</label>
                <input
                  type="number"
                  name="fixed_fee"
                  className="form-control"
                  value={publisherData?.fixed_fee}
                  onChange={handleChange}
                />
                </div>
              </div>

              <div className="col-md-6">
                <div className="publisher-field">
                <label>Revenue Sharing (%):</label>
                <input
                  type="number"
                  name="revenue_sharing"
                  className="form-control"
                  value={publisherData?.revenue_sharing}
                  onChange={handleChange}
                />
                </div>
              </div>
            </div>
        </div>
         {/* REPORTING OPTIONS */}
         <div className="form-section reporting-options">

          <h4 className="form-section-title">
            Reporting Options
          </h4>
            <div className="row">
              <div className="col-md-4">
                <div className="publisher-field">
                  <label>Show Request:</label>
                  <select
                    name="show_request"
                    className="form-control"
                    value={publisherData?.show_request}
                    onChange={handleChange}>
                    <option value="1">Yes</option>
                    <option value="0">No</option>
                    </select>
                    </div>
              </div>
            <div className="col-md-4">
              <div className="publisher-field">
              <label>Show Impression </label>
              <select
                name="show_impression"
                className="form-control"
                value={publisherData?.show_impression}
                onChange={handleChange}
              >
                <option value="1">Yes</option>
                <option value="0">No</option>
              </select>
              </div>
            </div>
            <div className="col-md-4">
               <div className="publisher-field">
              <label>Show CTR </label>
              <select
                name="show_ctr"
                className="form-control"
                value={publisherData?.show_ctr}
                onChange={handleChange}
              >
                <option value="1">Yes</option>
                <option value="0">No</option>
              </select>
              </div>
            </div>
            <div className="col-md-4">
              <div className="publisher-field">
              <label>Show PubRev</label>
              <select
                name="show_pubRev"
                className="form-control"
                value={publisherData?.show_pubRev}
                onChange={handleChange}
              >
                <option value="1">Yes</option>
                <option value="0">No</option>
              </select>
              </div>
            </div>
            <div className="col-md-4">
              <div className="publisher-field">
              <label>Show PubeCPM</label>
              <select
                name="show_pub_eCPM"
                className="form-control"
                value={publisherData?.show_pub_eCPM}
                onChange={handleChange}
              >
                <option value="1">Yes</option>
                <option value="0">No</option>
              </select>
              </div>
            </div>
        </div>
        </div>
        <div className="publisher-form-actions">
          <button type = "submit" className="publisher-submit-btn">Update</button>
          <button type = "button" className="btn settingsCancelBtn" onClick={() => navigate(-1)}>Cancel</button>
          </div>
        </form>
      </div>
    </div>
    </section>
    )
}

export default EditPublisher;